/** @module SiteAdmin/Document/AggregateReferenceDocument */
define([
	"dojo/_base/declare",
	"csi/action/FormData",
	"csi/table/AggregateFrom",
	"csi/wizard/ActionControllerMixin",
	"underscore",
	"csi/xml",
	"csi/xml/Query",

	"./OwnerTable"
], function(declare,FormData,AggregateFrom,ActionControllerMixin,_,xml,Query) {

	return declare([AggregateFrom, ActionControllerMixin], {
		/** @property {FormData} _fdContainer - form data used to select a container */
		_fdContainer: null,

		/**
		 * @override
		 * Return true to disable next button.
		 */
		disableNext: function(wizard, page, index) {
			// check if any materials are selected
			const selected = Object.keys(this._fdContainer._mapSelections);
			return !selected || selected.length === 0;
		},

		/**
		 * @override
		 * Return true to disable finish button.
		 */
		disableFinish: function(wizard, page, index) {
			// Check if any documents are selected
			const selected = this.getFormData()._mapSelections;
			return !selected || Object.keys(selected).length === 0;
		},

		/**
		 * Add Documents to list of already aggregated nodes
		 */
		onFormData: function(fd) {
			var container = this.getParent();
			
			_.each(this.m_cache.getNodes(container.Documents), function(document) {
				fd.addAggregatedNode(document);
			});
		},
		
		/**
		 * For first page, only return nodes that have documents
		 */
		onWizardViewPreCreate: function(wizard, page, defView, viewParams) {
			if (wizard.getIndexOfPage(page) == 0) {
				viewParams.ownerQuery = new Query().Attr("CntDocuments", xml.OP_GREATER_THAN, 0);
			}
		},

		/**
		 * Setup form data for each page
		 */
		onNextPage: function(wizard, currentPage, nextPage, bFinish) {
			var index = wizard.getIndexOfPage(nextPage);
			var fd = this.getFormData();
			var bRefresh;
			var dfd;

			if (!bFinish) {
				if (index === 0) {
					fd = this._fdContainer = this._fdContainer || new FormData(this);
					fd.setNode(this.getParent());
					fd.m_bSelectOne = true;
					fd.m_bRequireOne = true;
				} else if (index == 1) {
					var node = this._fdContainer.getSelectedNode();
					var oldNode = fd.getNode();
					if (oldNode != node) {
						fd.setNode(node);
						fd.resetSelections();
						bRefresh = true;
					}
				}

				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		}
	});
});
